export default __webpack_public_path__ + "static/BayswaterCarousel_0000-c648c0645b7dbe0499b51911fe23d085.jpg";